import bcsDog from "./bcs_dog"
import bcsCat from "./bcs_cat"

const bcs = {
  bcsDog,
  bcsCat,
}

export default bcs
